// extracted by mini-css-extract-plugin
export default {"wrapper":"TranscriptTableControls_wrapper__WMOTW","controls":"TranscriptTableControls_controls__2ofjD","clearButton":"TranscriptTableControls_clearButton__zZDSN"};